<template>
  <div class="row d-flex justify-content-center">
    <div class="col-8 text-center mt-5">
      <img class="img-fluid" src="/media/logos/logo-dark.png" style="width: 100px;">
    </div>
    <div class="col-8 loading">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
  </div>

  <!-- end::Page Loader -->
</template>

<script>
export default {
  name: "GeneralLoading",
  props: {
    logo: String,
    spinnerClass: String
  }
};
</script>

<style lang="scss">

.loading {
  $colors: #7ef9ff, #89cff0, #4682b4, #0f52ba, #000080;
  display: flex;

  .dot {
    position: relative;
    width: 2em;
    height: 2em;
    margin: 0.8em;
    border-radius: 50%;

    &::before {
      position: absolute;
      content: "";
      width: 100%;
      height: 100%;
      background: inherit;
      border-radius: inherit;
      animation: wave 2s ease-out infinite;
    }

    @for $i from 1 through 5 {
      &:nth-child(#{$i}) {
        background: nth($colors, $i);

        &::before {
          animation-delay: $i * 0.2s;
        }
      }
    }
  }
}

@keyframes wave {
  50%,
  75% {
    transform: scale(2.5);
  }

  80%,
  100% {
    opacity: 0;
  }
}


</style>
